import { IntegratorType } from '../components/ref-badge/RefBadge'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { useIntegratorRefCode } from '@/features/actions/logic/useIntegratorRefCode'

const NANSEN_REF_CODE = 205
const BITGET_REF_CODE = 194
const IMTOKEN_REF_CODE = 202
const SUPPORTED_SAVINGS = [
  TokenSymbol('spUSDC'),
  TokenSymbol('spUSDT'),
  TokenSymbol('spETH'),
  TokenSymbol('sUSDC'),
] as const

export interface UseActiveIntegratorParams {
  savingsToken: Token
}

export function useActiveIntegrator({ savingsToken }: UseActiveIntegratorParams): IntegratorType | undefined {
  const integratorRefCode = useIntegratorRefCode()
  const isSupportedSavingsToken = SUPPORTED_SAVINGS.some((symbol) => symbol === savingsToken.symbol)

  if (!isSupportedSavingsToken) {
    return undefined
  }

  if (integratorRefCode === NANSEN_REF_CODE) {
    return 'nansen'
  }
  if (integratorRefCode === BITGET_REF_CODE) {
    return 'bitget'
  }
  if (integratorRefCode === IMTOKEN_REF_CODE) {
    return 'imtoken'
  }

  return undefined
}
